import { View, Text } from "react-native";
import CalendarIcon from "../../svgs/CalendarIcon";
import { EventDetailsQuery } from "./types";
import { formatEventDate } from "./helpers";

interface LocationSectionProps {
  event: EventDetailsQuery["event"];
}

export default function EventDateSection({ event }: LocationSectionProps) {
  const { endsAt, sessions, startsAt, timezone } = event;

  const showAndTime = sessions.length == 1;
  let titleText = "Event Date";
  if (showAndTime) {
    titleText += " & Time";
  }

  const eventTimes = formatEventDate(startsAt, endsAt, timezone, true);

  return (
    <View className="flex flex-row py-3">
      <CalendarIcon height={22} width={22} />
      <View className="flex-1 min-w-0 pl-2">
        <Text className="text-small-normal font-700 text-ink-darker">{titleText}</Text>
        <View className="flex-row flex-wrap">
          <Text className="text-small-normal text-ink-darker font-400 mr-1">{eventTimes}</Text>
        </View>
      </View>
    </View>
  );
}
